var isUndefined = function (value) {
    return value === undefined;
};
export default isUndefined;
//# sourceMappingURL=is-undefined.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/layout/node_modules/@antv/util/esm/lodash/is-undefined.js
// module id = null
// module chunks = 